import { getCurrentUser } from "aws-amplify/auth";
import { syncAmplifyReduxUserAttributes } from "../../services/authorization/thunks";
import { fetchApplicationRoles } from "../../util/login";
import {
  selectAuthenticatedUser,
  selectAuthenticatedUserRoles,
} from "../../services/authorization/slices";
import { ROUTE_KEYS, ROUTES } from "./constants";

export const getLoginRedirect = ({ url: _url }) => {
  let pathToRedirectTo = ''
  try {
    const url = new URL(_url);
    const { pathname, search } = url;
    let redirectPath = ROUTES[ROUTE_KEYS.LOGIN].path;
    let encodedPriorPath = "";
    if (pathname) {
      encodedPriorPath += pathname;
      encodedPriorPath += search || "";
    }
    if (encodedPriorPath && encodedPriorPath?.length > 1) {
      redirectPath += `?from=`;
      redirectPath += encodeURIComponent(`${encodedPriorPath}`);
    }
  
    pathToRedirectTo = redirectPath;
  } catch (error) {
    pathToRedirectTo = ROUTES[ROUTE_KEYS.LOGIN].path;
  }
  return pathToRedirectTo
};

export const getUserForLoader = async ({ dispatch, getState }) => {
  if (getState) {
    const state = getState();
    const user = selectAuthenticatedUser(state);
    const roles = selectAuthenticatedUserRoles(state);
    if (user?.osuid) {
      return {
        user,
        roles,
      };
    }
  }
  if (dispatch) {
    const { roles, ...user } = await dispatch(
      syncAmplifyReduxUserAttributes()
    ).unwrap();
    return {
      roles,
      user,
    };
  } else {
    const user = await getCurrentUser();
    const roles = await fetchApplicationRoles();
    return {
      roles,
      user,
    };
  }
};
